import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import LogoCircular from "../assets/LogoLine.png";
import { Link } from "react-router-dom";

export const Hero = () => {
  const [isSwitched, setIsSwitched] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsSwitched((prev) => !prev);
    }, 3000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <motion.div
      className="relative text-center min-h-screen flex items-center justify-center pb-32"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1.2 }}
    >
      {/* Background Video - covers all screens (no black areas) */}
      <div className="absolute inset-0 -z-50 overflow-hidden">
        <div className="relative w-full h-full">
          <iframe
            className="absolute top-1/2 left-1/2 w-[600%] h-[600%] md:w-[200%] md:h-[200%] -translate-x-1/2 -translate-y-1/2 pointer-events-none"
            src="https://www.youtube.com/embed/1-bLGdChz3Q?autoplay=1&mute=1&controls=0&showinfo=0&autohide=1&loop=1&playlist=1-bLGdChz3Q&modestbranding=1&playsinline=1"
            title="Background video"
            frameBorder="0"
            allow="autoplay; fullscreen"
          />
        </div>
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black opacity-50 z-0"></div>

      <div className="gap-4 h-screen w-screen text-white flex flex-col justify-center items-center text-center z-10">
        {/* Animated Text Switch */}
        <motion.h2
          className="text-3xl md:text-5xl font-bold"
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          <motion.span
            key={isSwitched}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.6 }}
            className="inline-block font-aboreto"
          >
            {isSwitched ? "Benvenuti" : "Välkommen"}
          </motion.span>
        </motion.h2>

        <motion.img
          src={LogoCircular}
          className="md:w-[500px] w-60"
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
        />

        {/* Buttons – improved UI, fully responsive */}

        {/* Buttons */}
        <motion.div
          className="mt-8 grid w-full max-w-xl grid-cols-1 gap-3 sm:grid-cols-3 px-4 md:px-0"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.35 }}
        >
          {/* Primary */}
          <button
            data-hash="405f9dbe95a742d7c2081356d4bb7852"
            className="waiteraid-widget inline-flex w-full items-center justify-center rounded-full bg-white px-6 py-3 font-aboreto font-bold tracking-wide text-stone-900 shadow-lg shadow-black/20 transition hover:-translate-y-[1px] hover:bg-white/95 focus:outline-none focus:ring-2 focus:ring-white/60"
          >
            Boka Bord
          </button>

          {/* Secondary */}
          <a
            href="https://qopla.com/restaurant/il-gradino/qmQ9E2bbwY/order"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex w-full items-center justify-center rounded-full border border-white/60 bg-white/0 px-6 py-3 font-aboreto font-bold tracking-wide text-white backdrop-blur transition hover:-translate-y-[1px] hover:bg-white hover:text-stone-900 focus:outline-none focus:ring-2 focus:ring-white/60"
          >
            Beställ online
          </a>

          {/* Secondary */}
          <Link
            to="/menu"
            className="inline-flex w-full items-center justify-center rounded-full border border-white/60 bg-white/0 px-6 py-3 font-aboreto font-bold tracking-wide text-white backdrop-blur transition hover:-translate-y-[1px] hover:bg-white hover:text-stone-900 focus:outline-none focus:ring-2 focus:ring-white/60"
          >
            Meny
          </Link>
        </motion.div>

        {/* Small hint (optional) */}
        <div className="pointer-events-none mt-10 text-xs text-white/60">
          Scrolla för mer
        </div>
      </div>
    </motion.div>
  );
};
